import React, { useEffect, useState }  from "react";
import { Card, ListGroup } from "react-bootstrap";
import styles from "./ProjectSelector.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUserSelectedProject } from "../../store/actions/projects";
import { getSelectorOptionsThunk } from "../../store/actions/selectorOptions";
import { setProjectSelectedAtLogin } from "../../store/reducers/projects/projectsSlicer";
import { getNextImage } from "../../store/actions/images/next";
import { logout } from "../../store/actions/authentication";
import { Modal, Button, Row, Col } from "react-bootstrap";
const token = localStorage.getItem("token");


const TermsModal = ({ show, handleClose, handleAccept, handleLogout }) => {
  return (
    <Modal size="xl" centered show={show} onHide={handleClose} backdrop="static" keyboard={false} style={{ background: '#000', color:'#fff', }}>
      <div style={{ background: '#0e2942', radius:'2px' }}>
      <Modal.Header closeButton style={{ background: '#0e2942' }}>
        <Modal.Title>
          <h4 className="mx-1 text-white">Disclaimer</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: '#0e2942' }}>
        <Row>
          <Col xs={12} lg={3} className="mb-2">
            <h6 className="text-white">PLATFORM<br />DISCLAIMER</h6>
            <p>The information provided by Envisionit Deep AI (“Company”, “we”, “our”, “us”) on RATify AI Assurance Tool Software-as-a-Service (the “Platform”) is for general informational purposes only. All information on the Platform is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Platform.</p><p>
              Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the Platform or reliance on any information provided on or produced or published by the Platform. Your use of the Platform and your reliance on any information on the Platform is solely at your own risk.</p>
          </Col>
          <Col xs={12} lg={3} className="mb-2">
            <h6 className="text-white">PROFESSIONAL<br />DISCLAIMER</h6>
            <p>The services provided on the Platform are for the validation and monitoring of third-party AI solutions based on the information uploaded or provided to the Platform. All findings and/or reports generated by the Platform are based on a algorithmic analysis of the information uploaded or provided on the Platform using machine learning technology.</p><p>
              The Platform therefore does not contain medical advice of any nature. The information is provided for general notification and is not a substitute for professional medical advice. Information produced or published by the Platform is intended to be used and must be used for notification purposes only and must be verified by an appropriately trained medical practitioner. Accordingly, before taking any actions based upon such information or relying on such information, you must consult an appropriately trained medical practitioner.</p>
               <p>The use or reliance of any information contained on this Platform is solely at your own risk.</p>
          </Col>
          <Col xs={12} lg={3} className="mb-2">
            <h6 className="text-white">LIMITATION<br />OF LIABILITY</h6>
            <p>
              The customer agrees and acknowledges that the Services do not give specific advice on individual patients and should only be used by authorised users acting within their clinical competencies. The Services are not a substitute for professional medical qualifications and are used at the customer's own risk.
            </p>
            <p>
              For the avoidance of doubt, Envisionit Deep AI is not liable for and does not guarantee compliance with any of the Customer's regulatory or legal obligations, including those which relate to patient care, medical advice, treatment, diagnosis and healthcare.
            </p>
            <p>The Customer assumes sole responsibility for results obtained from the use of the Services and the Documentation by the Customer, and for conclusions drawn from such use. Envisionit Deep AI shall have no liability for any damage caused by errors or omissions in any information or instructions, Images or scripts provided to Envisionit Deep AI by the Customer in connection with the Services, or any actions taken by Envisionit Deep AI at the Customer's direction.</p>
          </Col>
          <Col xs={12} lg={3} className="mb-2">
            <h6 className="text-white">&nbsp;<br /></h6>
            <p>All warranties, representations, conditions and all other terms of any kind whatsoever implied by statute or common law are, to the fullest extent permitted by applicable law, excluded from this agreement; and the services are provided to the Customer on an "as is" basis.</p>
            <h6 className="text-white">CONTACT US</h6>
            <p>Should you have any feedback, comments, requests for technical support or other inquiries, please contact us by email: <a href="mailto:info@envisionit.ai">info@envisionit.ai</a>.</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <Button className="btn btn-secondary rounded-pill bg-red mx-1" onClick={handleLogout}>
          Logout
        </Button>
        <Button className="btn btn-secondary bg-yellow rounded-pill" onClick={handleAccept}>
          Accept
        </Button>
      </Modal.Footer>
      </div>
    </Modal>
  );
};
const ProjectSelector = () => {
  const { projects } = useSelector((state) => state.projects);
  const { user } = useSelector((state) => state.user);
  const projectAtLoginData = useSelector(
    (state) => state.projects.projectSelectedAtLogin
  );
  const dispatch = useDispatch();
  const projectList = projects;

  const navigate = useNavigate();

  const handleProjectSelect = async (projectId) => {
    // console.log('project selector next', token)
    await dispatch(getNextImage(localStorage.getItem("token"), projectId, projectAtLoginData));
    await dispatch(setUserSelectedProject(projectId));
    await dispatch(getSelectorOptionsThunk(projectId));
    await dispatch(setProjectSelectedAtLogin(projectId));
    navigate(`/authorized/projects/${projectId}`);
  };

  function hasAccepted () {
    // console.log('user', user.id)
    let termsModal = true
    if ( user &&  user.id && localStorage.getItem(user.id) !== null) {
      // console.log('The key exists in local storage.')
      termsModal = false
    } else {
      termsModal = true
      // console.log('The key does not exist in local storage.')
    }
    return termsModal
    
  }
  const [termsModal, setTermsModal] = useState(hasAccepted());

  const handleClose = () => setTermsModal(false);
  const handleAccept = () => {
    localStorage.setItem(user.id, 'Accepted')
    setTermsModal(false);
  };
  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    // Handle logout logic
    setTermsModal(false);
  };
  return (
    <div className={styles.projectSelector}>
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.projectSelectorTitle}>
            Select a project:
          </Card.Title>
          <ListGroup className={styles.projectList}>
            {projectList.map((project, i) => (
              <ListGroup.Item
                key={project._id}
                className={styles.projectListItem}
                onClick={() => handleProjectSelect(project._id)}
              >
                <p className={styles.itemTitle}>{i+1}.  {project.name}</p>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
      <TermsModal show={termsModal} handleClose={handleClose} handleAccept={handleAccept} handleLogout={handleLogout} />
   
    </div>
  );
};

export default ProjectSelector;
